<template>
  <div>
    <ion-grid :class="$style['grid']">
      <ion-row>
        <ion-col size="8">
          <ion-input v-model="street" :placeholder="$t('global.fields.address.street')" autocomplete="off"
                     @input="emitValues"/>
        </ion-col>
        <ion-col size="4">
          <ion-input v-model="number" :placeholder="$t('global.fields.address.number')" autocomplete="off"
                     @input="emitValues"/>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="4">
          <ion-input v-model="zip" :placeholder="$t('global.fields.address.zip')" autocomplete="off"
                     @input="emitValues"/>
        </ion-col>
        <ion-col size="8">
          <ion-input v-model="city" :placeholder="$t('global.fields.address.city')" autocomplete="off"
                     @input="emitValues"/>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-select v-model="country" :class="$style['select']" :placeholder="$t('global.fields.address.country')"
                      autocomplete="off"
                      @input="emitValues">
            <ion-select-option v-for="(country, key) in countries" :key="key" :value="key">
              {{ country.name }}
            </ion-select-option>
          </ion-select>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { IonCol, IonGrid, IonInput, IonRow, IonSelect, IonSelectOption } from "@ionic/vue";

import { countries } from 'countries-list';

declare type Address = {
  street: string;
  number: string;
  zip: string;
  city: string;
  country: string;
}

export default defineComponent({
  components: {IonInput, IonGrid, IonRow, IonSelect, IonSelectOption, IonCol},
  setup() {
    return {countries}
  },
  props: ['value'],
  emits: ['change'],
  data() {
    return {} as Address
  },
  mounted() {
    console.log(this.$props.value);
  },
  methods: {
    emitValues() {
      this.$emit('change', {
        street: this.street,
        number: this.number,
        zip: this.zip,
        city: this.city,
        country: this.country
      });
    }
  },
});
</script>

<style lang="scss" module>
.grid {
  --ion-grid-padding: 0;
  --ion-grid-column-padding: 0;
}

.select {
  width: 100%;
  --padding-start: 0;
  --padding-end: 0;
}
</style>